export const state = {

}

export const mutations = {

}

export const getters = {
  
}

export const actions = {

}



// WEBPACK FOOTER //
// ./src/state/modules/events.js